import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import './App.css';
import { ThemeProvider } from './ThemeContext';
import Navigation from './components/Navigation';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import Footer from './components/Footer';

function App() {
  return (
    <MotionConfig reducedMotion="user">
    <ThemeProvider>
      <Router>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
          </Routes>
          <Footer />
          <CookieBanner />
        </div>
      </Router>
    </ThemeProvider>
    </MotionConfig>
  );
}

export default App;
